module.exports = __webpack_public_path__ + "img/pc_banner_sup_pay.1f4fdd21.webp";